import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { TooltipDirective } from '@blaze-shared/shared-ui';

import { ChatMemberInfo } from '../chat.models';
import { InitialsPipe } from '../user-avatar/initials.pipe';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';
import { UserStatusDescriptionPipe } from '../utils/user-status-description.pipe';

@Component({
  selector: 'be-chat-list-item',
  templateUrl: './chat-list-item.component.html',
  styleUrls: ['./chat-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UserAvatarComponent, InitialsPipe, TooltipDirective, UserStatusDescriptionPipe],
})
export class ChatListItemComponent {
  isSelected = input(false);
  imageSrc = input<string | undefined>(undefined);
  title = input('');
  participantCount = input.required<number>();
  unreadCount = input(0);
  maxDisplayedUnreadCount = input(99);
  colorInfo = input<{ foreground: string; background: string } | undefined>(undefined);
  status = input.required<ChatMemberInfo[]>();

  selectItem = output<void>();

  unreadCountDisplayValue = computed(() => {
    const unreadCount = this.unreadCount();
    if (!unreadCount) {
      return '';
    }
    return unreadCount > this.maxDisplayedUnreadCount()
      ? this.maxDisplayedUnreadCount() + '+'
      : unreadCount;
  });

  isGroupChat = computed((): boolean => {
    return this.participantCount() > 2;
  });
}
